var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0442 3.28224L13.1975 0.542241C12.826 0.206336 12.3391 0.0135995 11.8295 0.000692758C11.32 -0.012214 10.8233 0.15561 10.4339 0.472241L1.08335 9.47224C0.74753 9.7982 0.53843 10.2254 0.491153 10.6822L0.0444057 14.8522C0.03041 14.9987 0.0501556 15.1463 0.102235 15.2846C0.154314 15.4229 0.237444 15.5484 0.345701 15.6522C0.44278 15.7449 0.557912 15.8182 0.684495 15.868C0.811078 15.9178 0.946621 15.943 1.08335 15.9422H1.17686L5.50927 15.5622C5.98386 15.5167 6.42774 15.3155 6.7664 14.9922L16.1169 5.99224C16.4799 5.62321 16.676 5.13075 16.6624 4.62278C16.6487 4.1148 16.4264 3.63275 16.0442 3.28224ZM12.5118 6.62224L9.7274 3.94224L11.7534 1.94224L14.5897 4.67224L12.5118 6.62224Z",
    className: "symbol"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.8b0ad160.svg";
export { ForwardRef as ReactComponent };